<script>
export default {
    name: "LabReportPrint",

    data() {

        return {
            tests: []
        };
    },

    computed: {

        totalBelow5() {
            const patients = this.tests.filter(test => test.age < 5);

            return patients.length;
        },

        totalAbove5() {
            const patients = this.tests.filter(test => test.age >= 5);

            return patients.length;
        },
    },

    mounted() {

        this.$root.loading=true;
        Promise.allSettled([ this.fetchLabReport(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchLabReport() {
            let url = `Lab/GetLabResults`;
                url += `?DateFrom=${this.$route.query.DateFrom}`;
                url += `&DateTo=${this.$route.query.DateTo}`;
                url += this.$route.query.SearchText ? 
                    `&SearchText=${this.$route.query.SearchText}` : ``;
                url += this.$route.query.ServiceId ? 
                    `&ServiceId=${this.$route.query.ServiceId}` : ``;
                url += this.$route.query.ComponentID ? 
                     `&ComponentResultId=${this.$route.query.ComponentID}` :
                     ``;

            return this.$http.get(url).then(response => {
                this.tests=response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap mx-1">
        <tail-address-header></tail-address-header>
        <div class="w-full text-center my-2">
            <h5 class="font-medium text-base uppercase">Completed Lab Investigations</h5>
        </div>
        <table class="table">
            <tbody class="font-semibold">
                <tr class="text-xs">
                    <th class="p-tiny">Req Date</th>
                    <th class="p-tiny">Patient</th>
                    <th class="p-tiny">IP NO</th>
                    <th class="p-tiny">OP NO</th>
                    <th class="p-tiny">Gender</th>
                    <th class="p-tiny">Age</th>
                    <th class="p-tiny">Test</th>
                    <th class="p-tiny">Component</th>
                    <th class="p-tiny">P Mode</th>
                    <th class="p-tiny">Ref No</th>
                    <th class="p-tiny">Req By</th>
                </tr>
                <tr v-for="(test,idx) in tests" :key="idx" class="text-xs">
                    <td class="p-tiny">
                        {{ test.date | dateFormat }}
                    </td>
                    <td class="p-tiny">
                        {{ test.patient }}
                    </td>
                    <td class="p-tiny">
                        {{ test.ipfileno || `-` }}
                    </td>
                    <td class="p-tiny">
                        {{ test.opfileno || `-` }}
                    </td>
                    <td class="p-tiny">
                        {{ test.gender }}
                    </td>
                    <td class="p-tiny">
                        {{ test.age }}
                    </td>
                    <td class="p-tiny">
                        {{ test.test }}
                    </td>
                    <td class="p-tiny">
                        {{ test.componentName || `-` }}
                    </td>
                    <td class="p-tiny">
                        {{ test.paymentMode || `-` }}
                    </td>
                    <td class="p-tiny">
                        {{ test.paymentRefNo || `-` }}
                    </td>
                    <td class="p-tiny">
                        {{ test.userName}}
                    </td>
                </tr>
                <tr>
                    <th colspan="3" class="p-1">
                        Below Age 5: {{ totalBelow5 }}</th>
                    <th colspan="4" class="p-1">
                        Above Age 5: {{ totalAbove5 }}
                    </th>
                    <td colspan="3" class="p-1">Total: {{ tests.length }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>